import React from "react";

import { usePrice } from "../../../hooks/usePrice";

import { Dialog, DialogButton, DialogContent, DialogFooter, DialogTitle } from "../../dialog";
import { Modal } from "../../modal";

import "./price-dialog.css";

export function PriceDialog({
	isOpen,
	onClose,
	title,
	total,
	close,
}: {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	total: string;
	close: string;
}) {
	const price = usePrice();

	if (!price) return null;

	return (
		<Modal isOpen={isOpen} onScrimClick={onClose}>
			<Dialog>
				<DialogTitle>{title}</DialogTitle>

				<DialogContent>
					{price.priceItems.map((item) => (
						<div key={item.description} className="price-list__item">
							<div className="price-list__line price-list__line--description">
								{item.description}
							</div>
							<div className="price-list__line">{item.calculationDescription}</div>
							<div className="price-list__line price-list__line--total">
								{item.itemTotal}
							</div>
						</div>
					))}

					<div className="price-list__item">
						<div className="price-list__line price-list__line--description">
							{total}
						</div>
						<div className="price-list__line price-list__line--total">
							{price.toString()}
						</div>
					</div>
				</DialogContent>

				<DialogFooter>
					<DialogButton type="button" onClick={onClose}>
						{close}
					</DialogButton>
				</DialogFooter>
			</Dialog>
		</Modal>
	);
}
